import { render, staticRenderFns } from "./WidgetMenu2.vue?vue&type=template&id=5484b26f&"
import script from "./WidgetMenu2.vue?vue&type=script&lang=js&"
export * from "./WidgetMenu2.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports